export enum ReserverStatusCode {
  "COOKIE_REQUIRED" = "S006",
  "INVALID_TOKEN_ERROR" = "F103",
  "JWT_TOKEN_EXPIRED" = "F104",
  "ATK_NOT_EXIST" = "F105",
}
